<script lang="ts">
	import { resolve } from '$app/paths';
	import { cookieConsent } from '$lib/utils/cookieConsent.svelte';
	import { reloadPage } from '$lib/utils/reload';
	import { Button } from '@hessianhq/ui';
	import { onMount } from 'svelte';
	import { APOLLO_SCRIPT_ID } from './apollo-pixel.svelte';

	let mounted = $state(false);

	onMount(() => {
		cookieConsent.hydrate();
		cookieConsent.resolveCountry();
		mounted = true;
	});

	const visible = $derived(
		mounted && (cookieConsent.state === 'unset' || cookieConsent.preferencesOpen)
	);

	function handleReject() {
		// If the Apollo tracker is already in the DOM — either auto-loaded in
		// a non-opt-in region, or previously injected after an Accept that the
		// user is now revoking — the IIFE has booted and is sending events.
		// Reload to tear it down; `state=rejected` then blocks re-injection on
		// the next page view.
		const trackerLoaded =
			typeof document !== 'undefined' &&
			document.getElementById(APOLLO_SCRIPT_ID) !== null;
		cookieConsent.reject();
		if (trackerLoaded) {
			reloadPage();
		}
	}
</script>

{#if visible}
	<div
		role="dialog"
		aria-live="polite"
		aria-label="Cookie consent"
		class="bg-background border-border fixed inset-x-4 bottom-4 z-50 mx-auto flex max-w-264 flex-col gap-4 rounded-2xl border p-5 shadow-lg sm:inset-x-6 sm:bottom-6 sm:flex-row sm:items-center sm:gap-6 sm:p-6"
	>
		<div class="text-soft-gray flex-1 text-sm leading-relaxed">
			<p class="text-primary font-medium">We use cookies</p>
			<p class="mt-1">
				We use cookies to understand how visitors use our site and to improve your experience. See
				our
				<a
					href={resolve('/legal/privacy')}
					class="text-primary underline underline-offset-2">privacy policy</a
				> for details.
			</p>
		</div>
		<div class="flex shrink-0 items-center gap-2">
			<Button
				variant="link"
				size="sm"
				class="[--ring:var(--destructive)]"
				onclick={handleReject}>Reject</Button
			>
			<Button size="sm" onclick={() => cookieConsent.accept()}>Accept</Button>
		</div>
	</div>
{/if}
